import type { I18N } from '@vista-digital/i18n'
import type { Event } from '@vista-digital/ocapi-types/v1'
import { gtm } from '@/common/services/gtm/gtm.service'
import { CurzonEcommerceDataLayer, CurzonEcommerceItem } from '@/common/services/models-gtm'

export class EventsGtmEvents {
    public static async viewEventDetail(event: Event, i18n: I18N) {
        const item = new CurzonEcommerceItem({
            item_name: i18n.translatable(event.name),
            item_category: 'Event',
        })
        await gtm.sendEcommerceDataLayer(
            new CurzonEcommerceDataLayer('view_item', {
                items: [item],
            })
        )
    }
}
